import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { TOUCH_HEIGHT, NON_TOUCH_HEIGHT } from '../SideNavigation.constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StyledHeader = styled.header(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  container-type: inline-size;\n  display: flex;\n  justify-content: space-between;\n  min-height: ", ";\n  overflow-x: ", ";\n  padding: ", ";\n  position: sticky;\n  border-bottom: ", ";\n  ", ";\n"])), function (_ref) {
  var $isTouch = _ref.$isTouch;
  return $isTouch ? TOUCH_HEIGHT : NON_TOUCH_HEIGHT;
}, function (_ref2) {
  var $isTouch = _ref2.$isTouch;
  return !$isTouch && 'hidden';
}, function (_ref3) {
  var $isTouch = _ref3.$isTouch,
    sizing = _ref3.theme.sizing;
  return $isTouch ? "0 ".concat(sizing.regular) : "0 ".concat(sizing.regular, " 0 ").concat(sizing.medium);
}, function (_ref4) {
  var _ref4$theme = _ref4.theme,
    colours = _ref4$theme.colours,
    sizing = _ref4$theme.sizing;
  return "".concat(sizing.xxtiny, " ").concat(colours.navigation.primary.main, " solid");
}, function (_ref5) {
  var $isTouch = _ref5.$isTouch,
    $isOpen = _ref5.$isOpen;
  return $isTouch && !$isOpen && "\n    border-bottom: none\n  ";
});
var MenuControlContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  order: ", ";\n"])), function (_ref6) {
  var $isTouch = _ref6.$isTouch;
  return $isTouch ? 'initial' : 1;
});
var LogoContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: ", ";\n"])), function (_ref7) {
  var $isOpen = _ref7.$isOpen,
    $isTouch = _ref7.$isTouch;
  return !$isOpen && $isTouch ? 'none' : 'flex';
});
var LogoTextContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  visibility: hidden;\n  /* Ensure the logo text is only visible when the container's width is greater than 3.5rem.\n     The header has padding of 1rem and 0.75rem on each side, which is why the min-width is 1.76rem.  */\n  @container (min-width: 1.76rem) {\n    visibility: visible;\n  }\n"])));

export { LogoContainer, LogoTextContainer, MenuControlContainer, StyledHeader };
//# sourceMappingURL=SideNavigationHeader.styles.js.map
